export default __webpack_public_path__ + "static/media/CAAR.07605e32.png";